// src/Pages/CoreModules/Infrastructure.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FacilityCoreRegistry       from '../../component/Infrastructure/Tabs/FacilityCoreRegistry';
import FacilityStatusUpdates      from '../../component/Infrastructure/Tabs/FacilityStatusUpdates';
import UnconfiguredSubmodulePlaceholder from '../../component/shared/UnconfiguredSubmodulePlaceholder';
import { TABS as LOCAL_TABS } from '../../component/Infrastructure/mockData/infraData';
import { useModuleTabs } from '../../config/moduleCatalog';
import { useAuth } from '../../context/AuthContext';

// R05 (LGA Field Officer) works only in Facility Status Update — the
// Facility Core Registry tab is hidden from them.
const HIDDEN_TABS_BY_ROLE = { R05: ['core'] };

const TAB_COMPONENTS = {
  core: FacilityCoreRegistry,
  status: FacilityStatusUpdates,
};

function TabNav({ tabs, active, onChange }) {
  return (
    <nav className="mb-5 flex flex-wrap gap-x-7 gap-y-2 border-b border-gray-200">
      {tabs.map(({ key, label }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`relative pb-3 text-sm ${
              isActive ? 'font-semibold text-green-600' : 'font-medium text-gray-700 hover:text-green-700'
            }`}
          >
            {label}
            {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded bg-green-600" />}
          </button>
        );
      })}
    </nav>
  );
}

export default function Infrastructure() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const allTabs = useModuleTabs('infrastructure', LOCAL_TABS);
  const hiddenTabs = HIDDEN_TABS_BY_ROLE[user?.roleId] ?? [];
  const tabs = allTabs.filter((t) => !hiddenTabs.includes(t.key));
  const segment = pathname.split('/').filter(Boolean).pop();
  const activeTab = tabs.some((t) => t.key === segment) ? segment : tabs[0]?.key;
  const activeTabDef = tabs.find((t) => t.key === activeTab);
  const ActiveView = TAB_COMPONENTS[activeTab] ?? (hiddenTabs.includes('core') ? FacilityStatusUpdates : FacilityCoreRegistry);

  return (
    <div className="p-6 bg-white min-h-screen">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-gray-900 leading-none">Infrastructure &amp; Facilities</h1>
          <p className="text-xs text-gray-400 mt-1">Facilities registry, licensing, and inspection management</p>
        </div>
        <span className="text-xs font-semibold text-gray-400 mt-1 italic">FMLD-native</span>
      </div>

      <TabNav tabs={tabs} active={activeTab} onChange={(key) => navigate(`/infrastructure/${key}`)} />
      {activeTabDef?.isCatalogOnly ? <UnconfiguredSubmodulePlaceholder label={activeTabDef.label} /> : <ActiveView />}
    </div>
  );
}
